export const data = [
  {
    id: "1",
    name: "Spaghetti Carbonara",
    description: "Classic Italian pasta dish with bacon, eggs, and cheese.",
    user: "ItalianChef",
    goto: "#",
    requirements: [
      "Spaghetti",
      "Bacon",
      "Eggs",
      "Parmesan Cheese",
      "Black Pepper",
    ],
    steps: [
      ["Cook pasta in salted boiling water until al dente."],
      ["Reserve some pasta water."],
      [
        "In a separate pan, cook diced bacon until crispy.",
        "Remove excess fat.",
      ],
      ["In a bowl, whisk eggs with grated Parmesan cheese and black pepper."],
      [
        "Add cooked spaghetti to the pan with bacon.",
        "Pour in egg mixture.",
        "Stir quickly to combine.",
      ],
      [
        "If too dry, add reserved pasta water to create a creamy sauce.",
        "Serve hot with extra cheese.",
      ],
    ],
  },
  {
    id: "2",
    name: "Tofu Stir-Fry",
    description:
      "Healthy and flavorful stir-fry with tofu, vegetables, and soy sauce.",
    user: "HealthyEats",
    goto: "#",
    requirements: [
      "Tofu",
      "Vegetables (such as bell peppers, broccoli, carrots)",
      "Soy Sauce",
      "Garlic",
      "Ginger",
      "Sesame Oil",
    ],
    steps: [
      ["Press tofu to remove excess water."],
      ["Cut tofu into cubes."],
      ["Heat sesame oil in a pan."],
      ["Add minced garlic and ginger.", "Sauté until fragrant."],
      ["Add tofu cubes to the pan.", "Cook until browned on all sides."],
      [
        "Add chopped vegetables and soy sauce.",
        "Stir-fry until vegetables are tender-crisp.",
      ],
      [
        "Serve hot with rice or noodles.",
        "Garnish with sesame seeds and green onions.",
      ],
    ],
  },
  {
    id: "3",
    name: "Chicken Tikka Masala",
    description: "Rich and creamy Indian curry dish with marinated chicken.",
    user: "SpiceMaster",
    goto: "#",
    requirements: [
      "Chicken",
      "Yogurt",
      "Heavy Cream",
      "Tomato",
      "Spices (such as cumin, coriander, paprika, turmeric, etc.)",
    ],
    steps: [
      [
        "Marinate chicken pieces in a mixture of yogurt and spices for at least 1 hour.",
      ],
      [
        "Heat oil in a pan and add marinated chicken.",
        "Cook until browned on all sides.",
      ],
      ["In a separate pan, sauté onions, garlic, and ginger until softened."],
      ["Add chopped tomatoes and cook until they break down and form a sauce."],
      ["Pour in heavy cream, stir well, and add the cooked chicken pieces."],
      ["Simmer for 10-15 minutes until the sauce thickens."],
      ["Serve hot with rice or naan."],
    ],
  },
  {
    id: "4",
    name: "Vegetable Pad Thai",
    description: "Thai noodle dish with mixed vegetables, tofu, and peanuts.",
    user: "ThaiFoodie",
    goto: "#",
    requirements: [
      "Rice Noodles",
      "Tofu",
      "Bean Sprouts",
      "Green Onions",
      "Peanuts",
      "Eggs",
      "Tamarind Paste",
      "Fish Sauce",
      "Soy Sauce",
      "Sugar",
    ],
    steps: [
      ["Soak rice noodles in warm water until softened."],
      ["Drain and set aside."],
      ["Heat oil in a wok."],
      ["Add minced garlic and tofu cubes.", "Sauté until tofu is golden."],
      [
        "Push tofu to one side of the wok.",
        "Crack eggs into the empty space.",
        "Scramble until cooked.",
      ],
      [
        "Add soaked noodles to the wok.",
        "Pour in tamarind paste, fish sauce, soy sauce, and sugar.",
        "Stir well.",
      ],
      [
        "Add bean sprouts and green onions.",
        "Toss everything together until heated through.",
      ],
      ["Serve hot garnished with crushed peanuts and lime wedges."],
    ],
  },
  {
    id: "5",
    name: "Beef Tacos",
    description:
      "Mexican street food classic with seasoned beef, salsa, and toppings.",
    user: "TacoTuesday",
    goto: "#",
    requirements: [
      "Beef",
      "Tortillas",
      "Tomatoes",
      "Lettuce",
      "Cheese",
      "Onions",
      "Salsa",
      "Avocado",
      "Cilantro",
      "Lime",
    ],
    steps: [
      ["Heat a skillet over medium-high heat."],
      [
        "Add ground beef and cook until browned.",
        "Break up the meat with a spatula as it cooks.",
      ],
      ["Drain excess fat from the skillet."],
      ["Season beef with taco seasoning.", "Stir well to combine."],
      ["Warm tortillas on a separate skillet or in the microwave."],
      [
        "Assemble tacos with seasoned beef, diced tomatoes, shredded lettuce, cheese, onions, salsa, sliced avocado, and cilantro.",
      ],
      ["Squeeze lime juice over the tacos.", "Serve hot and enjoy!"],
    ],
  },
  {
    id: "6",
    name: "Sushi Rolls",
    description: "Assorted sushi rolls with fresh fish, avocado, and rice.",
    user: "SushiMaster",
    goto: "#",
    requirements: [
      "Sushi Rice",
      "Nori Sheets",
      "Assorted Fish (such as tuna, salmon, and shrimp)",
      "Avocado",
      "Cucumber",
      "Soy Sauce",
      "Wasabi",
      "Pickled Ginger",
    ],
    steps: [
      ["Prepare sushi rice according to package instructions."],
      ["Lay a sheet of nori on a bamboo sushi mat."],
      [
        "Spread a thin layer of rice over the nori, leaving a 1-inch border at the top.",
      ],
      [
        "Arrange sliced fish, avocado, and cucumber along the bottom edge of the nori.",
      ],
      [
        "Roll the sushi tightly using the bamboo mat.",
        "Press firmly to seal the edge.",
      ],
      ["Slice the sushi roll into bite-sized pieces."],
      ["Serve with soy sauce, wasabi, and pickled ginger."],
    ],
  },
  {
    id: "7",
    name: "Pesto Pasta",
    description: "Pasta dish with basil pesto, cherry tomatoes, and pine nuts.",
    user: "PastaLover",
    goto: "#",
    requirements: [
      "Pasta",
      "Basil Pesto",
      "Cherry Tomatoes",
      "Pine Nuts",
      "Parmesan Cheese",
      "Garlic",
      "Olive Oil",
    ],
    steps: [
      ["Cook pasta in salted boiling water until al dente."],
      ["Reserve some pasta water before draining."],
      ["In a large pan, heat olive oil over medium heat."],
      ["Add minced garlic and cook until fragrant."],
      ["Add cherry tomatoes and cook until they start to burst."],
      [
        "Toss in cooked pasta and basil pesto.",
        "Add reserved pasta water as needed to create a sauce.",
      ],
      ["Sprinkle with pine nuts and grated Parmesan cheese.", "Serve hot."],
    ],
  },
  {
    id: "8",
    name: "Hawaiian Pizza",
    description: "Pizza topped with ham, pineapple, and mozzarella cheese.",
    user: "PizzaFanatic",
    goto: "#",
    requirements: [
      "Pizza Dough",
      "Pizza Sauce",
      "Ham",
      "Pineapple",
      "Mozzarella Cheese",
    ],
    steps: [
      ["Preheat your oven to the highest temperature setting."],
      ["Roll out pizza dough on a floured surface."],
      ["Spread pizza sauce over the dough, leaving a border around the edges."],
      ["Top with sliced ham and pineapple chunks."],
      ["Sprinkle shredded mozzarella cheese over the toppings."],
      [
        "Bake in the preheated oven until the crust is golden and the cheese is bubbly.",
      ],
      ["Slice and serve hot."],
    ],
  },
  {
    id: "9",
    name: "Mushroom Risotto",
    description:
      "Creamy Italian rice dish cooked with mushrooms and Parmesan cheese.",
    user: "RisottoChef",
    goto: "#",
    requirements: [
      "Arborio Rice",
      "Mushrooms",
      "Vegetable Broth",
      "White Wine",
      "Parmesan Cheese",
      "Onion",
      "Garlic",
      "Butter",
    ],
    steps: [
      ["In a saucepan, heat vegetable broth and keep it warm over low heat."],
      ["In a separate pan, melt butter over medium heat."],
      ["Add diced onion and minced garlic.", "Sauté until softened."],
      ["Add Arborio rice to the pan.", "Stir well to coat with butter."],
      ["Pour in white wine and cook until absorbed."],
      [
        "Add sliced mushrooms to the pan.",
        "Cook until they release their moisture.",
      ],
      [
        "Gradually add warm vegetable broth to the rice, one ladleful at a time.",
        "Stir frequently until the rice is creamy and tender.",
      ],
      ["Stir in grated Parmesan cheese.", "Season with salt and pepper."],
      [
        "Serve hot, garnished with additional Parmesan cheese and chopped parsley.",
      ],
    ],
  },
  {
    id: "10",
    name: "Vegetarian Chili",
    description: "Hearty chili made with beans, vegetables, and spices.",
    user: "ChiliLover",
    goto: "#",
    requirements: [
      "Kidney Beans",
      "Black Beans",
      "Tomatoes",
      "Onion",
      "Bell Pepper",
      "Corn",
      "Vegetable Stock",
      "Chili Powder",
      "Cumin",
      "Paprika",
    ],
    steps: [
      ["Heat oil in a large pot over medium heat."],
      ["Add diced onion and bell pepper.", "Sauté until softened."],
      [
        "Stir in chili powder, cumin, and paprika.",
        "Cook for 1-2 minutes until fragrant.",
      ],
      [
        "Add diced tomatoes, drained and rinsed beans, corn, and vegetable stock.",
      ],
      ["Bring to a simmer and cook for 20-25 minutes, stirring occasionally."],
      ["Season with salt and pepper to taste."],
      [
        "Serve hot, garnished with chopped cilantro, shredded cheese, and a dollop of sour cream.",
      ],
    ],
  },
  {
    id: "11",
    name: "Greek Salad",
    description:
      "Refreshing salad with tomatoes, cucumbers, olives, and feta cheese.",
    user: "SaladEnthusiast",
    goto: "#",
    requirements: [
      "Tomatoes",
      "Cucumbers",
      "Red Onion",
      "Kalamata Olives",
      "Feta Cheese",
      "Olive Oil",
      "Red Wine Vinegar",
      "Dried Oregano",
      "Salt",
      "Black Pepper",
    ],
    steps: [
      ["Dice tomatoes, cucumbers, and red onion."],
      ["Slice Kalamata olives and crumble feta cheese."],
      ["In a large bowl, combine diced vegetables, olives, and feta cheese."],
      [
        "In a small bowl, whisk together olive oil, red wine vinegar, dried oregano, salt, and black pepper.",
      ],
      ["Pour dressing over the salad and toss to coat evenly."],
      ["Serve immediately as a side dish or a light meal."],
    ],
  },
  {
    id: "12",
    name: "Crispy Fried Chicken",
    description: "Golden and crispy fried chicken with a flavorful coating.",
    user: "FriedChickenFan",
    goto: "#",
    requirements: [
      "Chicken Pieces (such as drumsticks, thighs, or breast)",
      "Buttermilk",
      "All-Purpose Flour",
      "Cornstarch",
      "Salt",
      "Pepper",
      "Paprika",
      "Garlic Powder",
      "Onion Powder",
      "Vegetable Oil",
    ],
    steps: [
      [
        "In a bowl, soak chicken pieces in buttermilk for at least 1 hour or overnight in the refrigerator.",
      ],
      [
        "In another bowl, mix all-purpose flour, cornstarch, salt, pepper, paprika, garlic powder, and onion powder.",
      ],
      ["Dredge chicken pieces in the flour mixture, shaking off excess."],
      [
        "Heat vegetable oil in a deep fryer or heavy-bottomed pot to 350°F (175°C).",
      ],
      [
        "Fry chicken pieces in batches until golden brown and cooked through, about 15-20 minutes depending on size.",
      ],
      [
        "Transfer fried chicken to a wire rack set over a baking sheet to drain excess oil.",
      ],
      ["Serve hot and enjoy the crispy goodness!"],
    ],
  },
  {
    id: "13",
    name: "Chocolate Cake",
    description: "Decadent chocolate cake perfect for any occasion.",
    user: "ChocoholicBaker",
    goto: "#",
    requirements: [
      "All-Purpose Flour",
      "Cocoa Powder",
      "Baking Powder",
      "Baking Soda",
      "Salt",
      "Butter",
      "Sugar",
      "Eggs",
      "Vanilla Extract",
      "Milk",
    ],
    steps: [
      ["Preheat the oven to 350°F (175°C)."],
      ["Grease and flour two 9-inch round cake pans."],
      [
        "In a bowl, sift together flour, cocoa powder, baking powder, baking soda, and salt.",
      ],
      ["In another bowl, cream butter and sugar until light and fluffy."],
      ["Add eggs, one at a time, beating well after each addition."],
      ["Mix in vanilla extract."],
      [
        "Gradually add dry ingredients to the creamed mixture, alternating with milk.",
      ],
      ["Divide batter evenly between prepared cake pans."],
      [
        "Bake in preheated oven for 25-30 minutes or until a toothpick inserted into the center comes out clean.",
      ],
      [
        "Cool cakes in pans for 10 minutes before transferring to wire racks to cool completely.",
      ],
      ["Frost and decorate as desired before serving."],
    ],
  },
  {
    id: "14",
    name: "Caprese Salad",
    description: "Simple and fresh salad with tomatoes, mozzarella, and basil.",
    user: "FreshEats",
    goto: "#",
    requirements: [
      "Tomatoes",
      "Fresh Mozzarella Cheese",
      "Fresh Basil Leaves",
      "Extra Virgin Olive Oil",
      "Balsamic Vinegar",
      "Salt",
      "Black Pepper",
    ],
    steps: [
      ["Slice tomatoes and fresh mozzarella cheese into thick slices."],
      [
        "Arrange tomato and mozzarella slices on a serving platter, alternating and overlapping them.",
      ],
      ["Tuck fresh basil leaves between the tomato and mozzarella slices."],
      ["Drizzle extra virgin olive oil and balsamic vinegar over the salad."],
      ["Season with salt and black pepper to taste."],
      ["Serve immediately as a refreshing appetizer or side dish."],
    ],
  },
];
